(function( $ ) {
	'use strict';

    $( document ).ready(function() {

        var $wpBodyContent = $('#wpbody-content'),
            spinnerClass = 'spinner',
            widgetContainer = '.wrap.pmwpp',
            apiKeyFieldSelector = '#pmwpp-pmwpp_apikey',
            settingsFormSelector = '.pmwpp-form',
            eventListSelector = '#pmwpp-pmwpp_eventid';

        $wpBodyContent.on('blur', apiKeyFieldSelector, function () {

            if ( $(this).val() !== $(this).data('value') ) {

                $( eventListSelector ).parent().hide();
            }
            else {

                $( eventListSelector ).parent().show();
            }
        });

        $wpBodyContent.on('change', eventListSelector, function () {

            var $widget = $( widgetContainer ),
                $form = $widget.find( settingsFormSelector ),
                $button = $widget.find('[type=submit]'),
                $eventList = $(this);

            if ($form.length == 1) {

                $button.attr('disabled', 'disabled');
                $form.find('input').attr('readonly', true);
                $eventList.addClass( spinnerClass );
                return $form[0].submit();
            }
        });

        $wpBodyContent.on('mousedown', eventListSelector, function ( event ) {

            if ( $(this).hasClass( spinnerClass ) ) {

                event.preventDefault();
                this.blur();
                window.focus();
            }
        });
    });

})( jQuery );
